import { render, staticRenderFns } from "./AdminPromotion.vue?vue&type=template&id=1fb983ca&scoped=true&"
import script from "./AdminPromotion.vue?vue&type=script&lang=js&"
export * from "./AdminPromotion.vue?vue&type=script&lang=js&"
import style0 from "./AdminPromotion.vue?vue&type=style&index=0&id=1fb983ca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb983ca",
  null
  
)

export default component.exports